<template>
  <v-footer
    align-content-center
    app
    color="primary"
    v-if="$route.name !== 'Home'"
  >
    <span class="white--text mx-auto"
      >InfiniteTodos (v1.0) &copy; {{ new Date().getFullYear() }}</span
    >
  </v-footer>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style scoped></style>
